"use strict";

import { registerPostMessageListener, POST_MESSAGE_KEYS, IFRAME_APPS_IDS } from "../libs/postMessages";

export default context => {
    if (context === document) {

        const iframe = $(IFRAME_APPS_IDS.EVENT_GRID_IFRAME)[0] || null; 
        if (!iframe) {
            return;
        }

        iframe.onload = () => {
            registerPostMessageListener(managementUrl, POST_MESSAGE_KEYS.LOGIN_PARENT, (data) => {
                switch (data.action) {
                    case 'EVENT_GRID_LOGIN_PARENT_ON_BOOKMARK':
                        window.auth(window.siteActions.bookmark, { 
                            template: 'bookmarks',
                            templateArgs: { gid: data.resourceId },  
                            afterLoginArgs: { gid: data.resourceId }
                        });
                        break;
                    default:
                        window.auth();
                        break;
                }
            });
    
            registerPostMessageListener(managementUrl, POST_MESSAGE_KEYS.EVENT_GRID_OPEN_EVENT, (data) => {
                window.location.href = data.resourceUrl
            });
    
            registerPostMessageListener(managementUrl, POST_MESSAGE_KEYS.EVENT_GRID_COMMUNITY_FOOTER_ACTIONS, (data) => {
                switch (data.modal) {
                    case 'displayPrivacyPolicy':
                        openWindow('window-privacy');
                        break;
                    case 'displayTermsOfConditions':
                        openWindow('window-service');
                        break;
                    case 'displayContactUs':
                        openWindow('window-contact');
                        break;
                    case 'displayHelp':
                        openWindow('window-help');
                        break;
                    default:
                        break;
                }
    
            });
    
        };
    }
}
